import { parse } from 'yaml';

export async function loadYaml(path: string) {
  try {
    const response = await fetch(path);
    if (!response.ok) {
      console.error(`Failed to fetch ${path}: ${response.status} ${response.statusText}`);
      return null;
    }
    const text = await response.text();
    const data = parse(text);
    return data;
  } catch (error) {
    console.error(`Error loading YAML from ${path}`, error);
    return null;
  }
}